import { version } from '../package.json'

export const SDK_NAME = 'sdc-monitor'
export const SDK_VERSION = version
